import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Autocomplete,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    keywordname: "best betting",
    matchType: "Exact",
    linkType: "Exclusive",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 2,
    keywordname: "betting sites uk",
    matchType: "Exact",
    linkType: "Allow",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
  },
  {
    id: 3,
    keywordname: "sports betting",
    matchType: "Broad",
    linkType: "Exclusive",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 4,
    keywordname: "best betting sites",
    matchType: "Exact",
    linkType: "Allow",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
  },
  {
    id: 5,
    keywordname: "UK sports betting",
    matchType: "Broad",
    linkType: "Exclusive",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 6,
    keywordname: "best betting uk",
    matchType: "Broad",
    linkType: "Allow",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
  },
  {
    id: 7,
    keywordname: "sport gambling",
    matchType: "Broad",
    linkType: "Allow",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
  },
  {
    id: 8,
    keywordname: "betting",
    matchType: "Exact",
    linkType: "Allow",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 9,
    keywordname: "online betting sites",
    matchType: "Broad",
    linkType: "Allow",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
  },
  {
    id: 10,
    keywordname: "top sports betting",
    matchType: "Exact",
    linkType: "Exclusive",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
];
// Example options for the autocomplete
const definitionOptions = [
  { label: "High Intent", value: "high_intent" },
  { label: "Returning Visitors", value: "returning_visitors" },
  { label: "Promo Seekers", value: "promo_seekers" },
  { label: "All Visitors", value: "all_visitors" },
];

const SecondPositiveST = ({ open, rowData, onClose }: any) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    {
      field: "keywordname",
      headerName: "Keyword Name",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "matchType",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "linkType",
      headerName: "Link Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "AdgroupName",
      headerName: "Adgroup Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "campaignName",
      headerName: "Campaign Name",
      flex: 1,
      minWidth: 220,
    },
    {
      field: "Definition",
      headerName: "Definition",
      flex: 0.8,
      minWidth: 160,
      sortable: false,
      renderCell: () => (
        <Autocomplete
          size="small"
          options={definitionOptions}
          getOptionLabel={(option) => option.label}
          sx={{ width: "100%" }}
          renderInput={(paramsInput) => (
            <TextField
              {...paramsInput}
              placeholder="Select..."
              variant="standard"
              color="secondary"
              InputProps={{
                ...paramsInput.InputProps,
                disableUnderline: true, // 🔑 hides underline
              }}
            />
          )}
        />
      ),
    },
  ];

  if (!rowData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Other Keywords Related to the Search term: best betting{" "}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ width: "100%", display: "grid" }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            //   disableMultipleRowSelection
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
            initialState={{
              pinnedColumns: {
                left: ["keywordname", "matchType"],
                right: ["Definition"],
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "0px 20px 16px" }}>
        <Button color="secondary" variant="outlined" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SecondPositiveST;
